/** @format */

import React, { useEffect, useState } from 'react';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CardBody from '../../../components/Card/CardBody';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import CustomInputExt from '../../../components/CustomInput/CustomInputExt';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import MvnoBlockListInterface from '../../../interfaces/platform/MvnoBlockListInterface';
import { platformUserConstants } from '../../../modules/platformuser/actions';
import I18n from '../../../components/Translate/I18n';
import AlertConfirm from '../../../components/Info/AlertConfirm';
import { NotificationHelper } from '../../../helpers/NotificationHelper';
import { notificationConstants } from '../../../modules/notifications/notifications';
import CustomInputExtNumber from '../../../components/CustomInput/CustomInputExtNumber';

interface PlatformResellerConnectionLimitPropsInterface {
    readonly resellerId: string | null;
    isRootReseller: boolean;
}

interface PlatformResellerConnectionLimitInterface {
    rateLimitSecond?: number;
    rateLimitMinute?: number;
    processTransportActivation?: number;
    processTransportSynchronize?: number;
    processTransportCommon?: number;
    weightedRoundRobinValue?: number;
    skipConnectionLimit?: boolean;
    limitMessage?: string;
    readonly resellerId?: number;
}

const PlatformResellerConnectionLimit: React.FC<PlatformResellerConnectionLimitPropsInterface> = (props) => {
    const [resellerLimits, setResellerLimits] = useState<PlatformResellerConnectionLimitInterface>({});
    const [validationError, setValidationError] = useState<boolean>(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);

    //FIX BO Z WYZEJ PRZYCHODZI URL
    const [resellerId, setResellerId] = useState(props.resellerId);
    const [firstLoad, setFirstLoad] = useState(true);

    const dispatch = useDispatch();

    const validateRateLimits = (rateLimitSecond?: number, rateLimitMinute?: number): boolean => {
        if (rateLimitSecond && rateLimitMinute) {
            if (rateLimitMinute > rateLimitSecond * 60) {
                return true;
            }
        }
        return false;
    };

    useEffect(() => {
        if (resellerLimits.rateLimitSecond && resellerLimits.rateLimitMinute) {
            const error = validateRateLimits(resellerLimits.rateLimitSecond, resellerLimits.rateLimitMinute);
            setValidationError(error);
        }
    }, [resellerLimits.rateLimitSecond, resellerLimits.rateLimitMinute]);

    useEffect(() => {
        const fetchResellerLimit = (): void => {
            const itemLoaders = new ItemLoaders(dispatch);

            if (!resellerId) {
                return;
            }

            itemLoaders.getWithCallback(FormGeneralHelper.getByUri(resellerId), 'platform_reseller_connection_limits_loadItem', (data: any): void => {
                const dataReseller = {
                    rateLimitSecond: data.rateLimitSecond,
                    rateLimitMinute: data.rateLimitMinute,
                    processTransportActivation: data.processTransportActivation,
                    processTransportSynchronize: data.processTransportSynchronize,
                    processTransportCommon: data.processTransportCommon,
                    weightedRoundRobinValue: data.weightedRoundRobinValue,
                    skipConnectionLimit: data.skipConnectionLimit,
                    resellerId: data.id,
                    isRootReseller: props.isRootReseller,
                };
                setResellerLimits(dataReseller);
                setFirstLoad(false);
            });
        };

        const fetchRootValues = (): void => {
            const itemLoaders = new ItemLoaders(dispatch);
            if (!resellerId) {
                return;
            }
            const simpleResellerId = resellerId.split('/').pop();

            itemLoaders.getWithCallback(
                FormGeneralHelper.getUrl('/platform_reseller_connection_limits/' + simpleResellerId),
                'platform_reseller_connection_limits_loadItem',
                (data: any): void => {
                    const dataReseller = {
                        rateLimitSecond: data.rateLimitSecond,
                        rateLimitMinute: data.rateLimitMinute,
                        processTransportActivation: data.processTransportActivation,
                        processTransportSynchronize: data.processTransportSynchronize,
                        processTransportCommon: data.processTransportCommon,
                        limitMessage: data.limitMessage,
                        weightedRoundRobinValue: data.weightedRoundRobinValue,
                        resellerId: parseInt(simpleResellerId as string),
                        isRootReseller: props.isRootReseller,
                    };
                    setResellerLimits(dataReseller);
                    setFirstLoad(false);
                }
            );
        };

        if (firstLoad && resellerId) {
            props.isRootReseller ? fetchRootValues() : fetchResellerLimit();
        }
    }, [resellerId, firstLoad, props, dispatch]);

    const saveForm = (): void => {
        setConfirmDialogOpen(false)

        if (validationError) {
            return;
        }

        const itemLoaders = new ItemLoaders(dispatch);

        itemLoaders.putWithCallback(
            FormGeneralHelper.getUrl('/platform_reseller_connection_limits/' + resellerLimits.resellerId),
            platformUserConstants.DELETE,
            resellerLimits,
            {
                onSuccess: (data: any) => {
                    NotificationHelper.notifySaveSuccess(dispatch);
                },
                onError: (data: any) => {
                    NotificationHelper.notifyError('platform_reseller:connection.save_error', dispatch);
                },
            },
            { dispatchAfterCallback: false, dispatchErrorAfterCallback: true, propagateDataToCallback: false }
        );
    };



    return (
        <Card>
            <CardHeader trans={props.isRootReseller ? 'platform_reseller:h.allowed_connection_limit_root' : 'platform_reseller:h.allowed_connection_limit'} />
            <CardBody>
                <GridContainer>
                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            fullWidth={true}
                            labelText="platform_reseller:connection.rate_limit_second"
                            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
                                setResellerLimits({
                                    ...resellerLimits,
                                    rateLimitSecond: Number(event.currentTarget.value),
                                });
                            }}
                            value={resellerLimits?.rateLimitSecond}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            fullWidth={true}
                            labelText="platform_reseller:connection.rate_limit_minute"
                            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
                                setResellerLimits({
                                    ...resellerLimits,
                                    rateLimitMinute: Number(event.currentTarget.value),
                                });
                            }}
                            value={resellerLimits?.rateLimitMinute}
                        />
                    </GridItem>

                    {validationError && resellerLimits.rateLimitSecond && (
                        <GridItem xs={12}>
                            <Typography
                                variant="body2"
                                style={{
                                    color: '#f44336',
                                    marginTop: '8px',
                                    fontSize: '0.875rem',
                                }}
                            >
                                <I18n
                                    trans={'platform_reseller:connection.rate_limit_error'}
                                    valueObject={{
                                        rateLimitMinute: resellerLimits?.rateLimitMinute,
                                        rateLimitSecond: resellerLimits.rateLimitSecond * 60,
                                    }}
                                />
                            </Typography>
                        </GridItem>
                    )}

                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            fullWidth={true}
                            labelText="platform_reseller:connection.process_transport_activation"
                            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
                                setResellerLimits({
                                    ...resellerLimits,
                                    processTransportActivation: Number(event.currentTarget.value),
                                });
                            }}
                            value={resellerLimits?.processTransportActivation}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            fullWidth={true}
                            labelText="platform_reseller:connection.process_transport_synchronize"
                            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
                                setResellerLimits({
                                    ...resellerLimits,
                                    processTransportSynchronize: Number(event.currentTarget.value),
                                });
                            }}
                            value={resellerLimits?.processTransportSynchronize}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            fullWidth={true}
                            labelText="platform_reseller:connection.process_transport_common"
                            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
                                setResellerLimits({
                                    ...resellerLimits,
                                    processTransportCommon: Number(event.currentTarget.value),
                                });
                            }}
                            value={resellerLimits?.processTransportCommon}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            fullWidth={true}
                            labelText="platform_reseller:connection.weighted_round_robin_value"
                            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
                                setResellerLimits({
                                    ...resellerLimits,
                                    weightedRoundRobinValue: Number(event.currentTarget.value),
                                });
                            }}
                            value={resellerLimits?.weightedRoundRobinValue}
                        />
                    </GridItem>
                    <GridItem xs={12}>
                        {!props.isRootReseller && (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={Boolean(resellerLimits.skipConnectionLimit)}
                                        value={resellerLimits.skipConnectionLimit}
                                        name={'skipConnectionLimit'}
                                        onChange={(): void => {
                                            setResellerLimits({
                                                ...resellerLimits,
                                                skipConnectionLimit: !resellerLimits.skipConnectionLimit,
                                            });
                                        }}
                                    />
                                }
                                label={<I18n trans={'platform_reseller:connection.skip_connection_limit'} />}

                            />
                        )}

                        {props.isRootReseller && (
                            <Typography
                                variant="body2"
                                style={{
                                    color: '#f44336',
                                    marginTop: '8px',
                                    fontSize: '0.875rem',
                                }}
                            >
                                {resellerLimits.limitMessage}
                            </Typography>
                        )}
                    </GridItem>

                    <GridItem xs={10} />
                    <GridItem xs={2}>
                        <CustomTextButtom
                            callback={(): void => {
                                if (validationError) {
                                    return
                                }
                                setConfirmDialogOpen(true);
                            }}
                            color={'primary'}
                            size={'lg'}
                            label={'general:common.save'}
                            disabled={validationError}
                        />
                    </GridItem>
                </GridContainer>
            </CardBody>

            {confirmDialogOpen && (
                <AlertConfirm
                    content={'platform_reseller:connection.confirm'}
                    confirmBtnText={'general:common.confirm'}
                    cancelBtnText={'general:common.cancel'}
                    onConfirm={saveForm}
                    onCancel={():void => setConfirmDialogOpen(false)}
                />
            )}
        </Card>
    );
};

export default PlatformResellerConnectionLimit;
